import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '../lib/cn'

const kbdVariants = cva(
  cn(
    'bg-muted text-muted-foreground pointer-events-none inline-flex w-fit min-w-5 items-center justify-center gap-1 rounded-sm px-1 font-sans font-medium select-none',
    "[&_svg:not([class*='size-'])]:size-3",
    '[[data-slot=tooltip-content]_&]:bg-background/20 [[data-slot=tooltip-content]_&]:text-background dark:[[data-slot=tooltip-content]_&]:bg-background/10',
  ),
  {
    variants: {
      size: {
        xs: 'h-4 text-[10px]',
        sm: 'h-5 text-xs',
        md: 'h-7 text-sm',
        lg: 'h-9 text-base',
      },
    },
    defaultVariants: {
      size: 'sm',
    },
  },
)

export interface KbdProps extends React.ComponentPropsWithoutRef<'kbd'>, VariantProps<typeof kbdVariants> {}

const Kbd = React.forwardRef<HTMLElement, KbdProps>(({ className, size, ...props }, ref) => (
  <kbd ref={ref} data-slot='kbd' className={cn(kbdVariants({ size, className }))} {...props} />
))
Kbd.displayName = 'Kbd'

export type KbdGroupProps = React.ComponentPropsWithoutRef<'span'>

const KbdGroup = React.forwardRef<HTMLSpanElement, KbdGroupProps>(({ className, ...props }, ref) => (
  <span ref={ref} data-slot='kbd-group' className={cn('inline-flex items-center gap-1', className)} {...props} />
))
KbdGroup.displayName = 'KbdGroup'

export { Kbd, KbdGroup, kbdVariants }
